import TBodyRow from './TBodyRow';

interface IProps {
  moduleData: any;
  handleDelete: any;
  isView: boolean;
  machineData: any;
}

const TBody = ({ moduleData, isView, handleDelete, machineData }: IProps) => {
  return (
    <tbody>
      {moduleData?.map((item: any, index: number) => (
        <TBodyRow
          {...{
            item,
            index,
            isView,
            handleDelete,
            machineData,
          }}
        />
      ))}
    </tbody>
  );
};

export default TBody;
